import { ProposedToTheSubCommittee3ApproveViewComponent } from "../../../components/borrowSystem/ProposedToTheSubCommittee/ProposedToTheSubCommittee3ApproveViewComponent";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";

export function PoposedToTheSubCommittee3ApproveContainer() {
    const titleName = "มติที่ประชุม แบบเสนอคณะอนุกรรมการพิจารณาให้กู้ยืมกองทุนพัฒนาฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
    const subtitle = "(สำหรับผู้ดำเนินการฝึกและผู้ประกอบกิจการ)"
    return (
        <div className="page-container bg-landing">
            <NavbarBorrowSystem />
            <HeadTitle title={titleName} subtitle={subtitle} />
            <ProposedToTheSubCommittee3ApproveViewComponent />
            <Footer />
        </div>

    )
}




